import { generateBulletPointItem } from './generateBulletPointItem';
import lodashGet from 'lodash.get';
import { useUpdateStructure } from '../../../../../../../../../../hooks/useUpdateStructure';
import { isLength } from '../../../../../../../../../../../../../../../../lib/util/helpers';
import { useLocalization } from '../../../../../../../../../../../../../../../../lib/hooks/useLocalization';
import { QuestionnaireTextButton } from '../../../../../../../../../../features/QuestionnaireTextButton';

const MAX_BULLET_POINTS_AMOUNT = 8;

export function AddBulletPointButton({ structureItemIndex, productIndex, data, dataPath, disabled, ...rest }) {
  const areBulletPointsReachedLimit = isLength(data.bulletPoints) && data.bulletPoints?.length >= MAX_BULLET_POINTS_AMOUNT;
  const { updateStructure } = useUpdateStructure();
  const { generic } = useLocalization().translations.shared;

  const add = () => {
    updateStructure(draft => {
      const bulletPoints = lodashGet(draft, dataPath);
      bulletPoints.push(generateBulletPointItem());
    });
  };

  return (
    <div {...rest}>
      <QuestionnaireTextButton textValue={generic.addBulletPoint} disabled={disabled || areBulletPointsReachedLimit} onClick={add} />
    </div>
  );
}
